<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faExclamationTriangle,
);
export default {
  data() {
    return {
      module: null,
    };
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
  },
};
</script>

<template lang="html">
  <div class="page-not-found is-flex">
    <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="4x"/>
    <div class="page-message is-size-5">
      <p>Sorry, the page you are looking for does not exist.</p>
      <p style="display: ;">
        Try going
        <router-link
          v-if="this.activeModule.name === 'directMatch'"
          :to="{ name: 'directMatch' }"
        >
          <span>home</span>
        </router-link>
        <router-link
          v-if="this.activeModule.name === 'locationID'"
          :to="{ name: 'locationID' }"
        >
          <span>home</span>
        </router-link>
        <span>.</span>
      </p>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .page-not-found
    height: 100vh
    align-items: center
    justify-content: center
    flex-direction: column
  .page-message
    margin-top: 1rem
</style>
